const Revenue = () => import('./Revenue.vue')

const List = () => import('./pages/List.vue')
const Create = () => import('./pages/Create.vue')
const Edit = () => import('./pages/Edit.vue')

const routes = {
  component: Revenue,
  path: '/faturamentos',
  meta: {
    label: 'Faturamentos'
  },
  children: [
    {
      path: '',
      component: List,
      name: 'revenuesList',
      meta: {
        label: 'Gerenciar Faturamentos',
        requiredPermission: {resource: 'revenue', value: 'view'}
      }
    },
    {
      path: 'cadastro',
      component: Create,
      name: 'revenueCreate',
      meta: {
        hidden: true,
        label: 'Cadastrar',
        requiredPermission: {resource: 'revenue', value: 'manage'}
      }
    },
    {
      path: 'atualizar/:id',
      component: Edit,
      name: 'revenueEdit',
      meta: {
        hidden: true,
        label: 'Atualizar',
        requiredPermission: {resource: 'revenue', value: 'manage'}
      }
    }
  ]
}

export default routes



// WEBPACK FOOTER //
// ./src/pages/revenue/routes.js